import { render, staticRenderFns } from "./SortButton.vue?vue&type=template&id=15366a42"
import script from "./SortButton.vue?vue&type=script&lang=js"
export * from "./SortButton.vue?vue&type=script&lang=js"
import style0 from "./SortButton.vue?vue&type=style&index=0&id=15366a42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports